import './styles/main.scss'
import './styles/pages/_pricing.scss'
import './scripts/common'
import './scripts/nav'
import './scripts/footer'
import RangeInput from './models/RangeInput'
import { $, $$, comma, roundX } from './utils'
import { PRICING_LVS, getPricingLvs, toTenThousand } from '@landing/official-common/consts/pricing'


const dom = $('#pricing-table')
const trs = $$('table > tbody > tr', dom)
const resBar = $('[data-res]', dom)

const change = res => {
  const { value } = res
  const rows = getPricingLvs(value)

  let totalFee = 0

  trs.forEach((tr, i) => {
    const row = rows[i]
    const tds = $$('td', tr)
    if (row) {
      totalFee += row.fee
      const value = toTenThousand(row.value)
      const percent = (row.rate * 100) + '%'
      const fee = comma(roundX(row.fee)) + ' 元'
      tds[1].textContent = value + ' X'
      tds[2].textContent = percent + ' ='
      tds[3].textContent = fee
    }
    else {
      const percent = (PRICING_LVS[i].rate * 100) + '%'
      tds[1].textContent = '0 X'
      tds[2].textContent = percent + ' ='
      tds[3].textContent = '0'
    }
  })
  resBar.textContent = `月收單 ${toTenThousand(value)}，系統費為 ${comma(Math.floor(totalFee)) + ' 元'}`
}

new RangeInput('#range-input', {
  value: 500000,
  max: 13000000,
  change
})
